import React, { FC, ReactNode, useState, useEffect } from 'react';
import styled from 'styled-components';
import { GenericListHead } from './GenericListHead';
import { GenericListBody } from './GenericListBody';
import { GenericListFooter } from './GenericListFooter';

const Wrapper = styled.div`
  width: 100%;
  display: grid;
`;

export interface GenericListColumn {
  name: string;
  displayName?: string;
  sortable?: boolean;
  widthTemplate?: string;   // default: 1fr
  formatFn?: (value: any, collapsed?: boolean, item?: any) => ReactNode;
}

export interface GenericListProps {
  displayColumnNames?: boolean;
  collapsible?: boolean;
  columns: GenericListColumn[];
  items: any[];
  itemsPerPage?: number;
  additionalRenderFn: (item: any, collapsed: boolean) => ReactNode;
  additionalContentConfig?: { columnTemplate: string };
  initialSortingColumn?: string | { column: string, asc: boolean };
  countLabel?: string;
  firstItemOpen?: boolean;
}

export interface SortByProps {
  column: string;
  asc: boolean
}

export const GenericList: FC<GenericListProps> = (props) => {
  const {
    displayColumnNames = false,
    columns = [],
    items, itemsPerPage = 10,
    collapsible = false,
    additionalRenderFn, additionalContentConfig,
    initialSortingColumn,
    countLabel,
    firstItemOpen = false,
  } = props;
  const [sortBy, setSortBy] = useState<SortByProps>({
    column: (initialSortingColumn ? (typeof initialSortingColumn === 'string' ? initialSortingColumn : initialSortingColumn?.column) : columns[0].name),
    asc: typeof initialSortingColumn === 'object' ? initialSortingColumn?.asc : true,
  });

  const [page, setPage] = useState(0);
  useEffect(() => setPage(0), [items]);

  return (
    <Wrapper>
      {
        (displayColumnNames && columns) &&
        <GenericListHead
          columns={columns}
          collapsible={collapsible}
          changeSortCallback={(column: string, asc: boolean) => {
            setSortBy({ column, asc });
          }}
          sortBy={sortBy}
        />
      }
      {
        items &&
        <GenericListBody items={items}
                         columns={columns}
                         collapsible={collapsible}
                         additionalContentConfig={additionalContentConfig}
                         additionalRenderFn={additionalRenderFn}
                         firstItemOpen={firstItemOpen}
                         pagination={{
                           page,
                           itemsPerPage,
                         }}
                         sortBy={sortBy} />
      }
      {
        <GenericListFooter
          page={page}
          pagesCount={Math.ceil(items ? items?.length / itemsPerPage : 1)}
          onPageChange={(page) => setPage(page)}
          countLabel={countLabel}
        />
      }
    </Wrapper>
  );
};
